import React from "react";
import { Container as BaseContainer } from "@wearewqa/wqa-design-system";

interface ContainerProps {
  children: React.ReactNode;
}

export const Container: React.FC<ContainerProps> = ({ children }) => {
  return (
    <BaseContainer maxWidth="xl" padding="md" center>
      {children}
    </BaseContainer>
  );
};
